let elements = {
  //pick: 3,
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page029_game0/img/bcg3.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page029_game0/audio/false.mp3',
    // positive: 'games/page029_game0/audio/empty_true.mp3',
    // click: 'games/page029_game0/audio/click.mp3',
    icon: {
      on: 'games/page029_game0/img/audioOn.png',
      off: 'games/page029_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 20,
    height: 20,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 218,
    height: 214,
  },
  layoutItems: [
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 93,
        y: 126,
      },
    },
    {
      pos: {
        x: 976,
        y: 173,
      },
    },
    {
      pos: {
        x: 1424,
        y: 173,
      },
    },

    {
      pos: {
        x: 521,
        y: 173,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: false,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page029_game0/audio/37_catch.mp3',

          correct: {
            audioId: 'a02',
            image: {
              src: 'games/page029_game0/img/3nie.webp',
            },
            width: 369,
            height: 514,
            correctItems: {
              images: [
                {
                  src: 'games/page029_game0/img/3nieok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 369,
                  height: 514,
                },
              ],
              text: [],
            },
          },
        },
        {
          // audioSrc: 'games/page029_game0/audio/39_dance.mp3',
          alwaysCorrect: true,

          correct: {
            audioId: 'a01',
            image: {
              src: 'games/page029_game0/img/3ok.webp',
            },
            width: 420,
            height: 393,
            incorrectItems: {
              images: [
                {
                  src: 'games/page029_game0/img/3ok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 420,
                  height: 393,
                },
              ],
              text: [],
            },
          },
        },
        {
          // audioSrc: 'games/page029_game0/audio/39_dance.mp3',
          alwaysCorrect: true,

          correct: {
            audioId: 'a01',
            image: {
              src: 'games/page029_game0/img/3ok.webp',
            },
            width: 420,
            height: 393,
            incorrectItems: {
              images: [
                {
                  src: 'games/page029_game0/img/3ok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 420,
                  height: 393,
                },
              ],
              text: [],
            },
          },
        },
        {
          // audioSrc: 'games/page029_game0/audio/39_dance.mp3',
          alwaysCorrect: true,

          correct: {
            audioId: 'a01',
            image: {
              src: 'games/page029_game0/img/3ok.webp',
            },
            width: 420,
            height: 393,
            incorrectItems: {
              images: [
                {
                  src: 'games/page029_game0/img/3ok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 420,
                  height: 393,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page029_game0/audio/41_paint.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page029_game0/img/audioOn.png', iconOff: 'games/page029_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 545 - 20,
        x: 165,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page029_game0/audio/37_catch.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page029_game0/img/audioOn.png', iconOff: 'games/page029_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 590 - 20,
        x: 130,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
  ],
};

export default elements;
